import React from "react";
import InputField, { InputFieldProps } from "../InputField/InputField";

const TextField = React.forwardRef<
  HTMLInputElement,
  Omit<InputFieldProps, "InputComponent">
>(({ ...props }, ref) => {
  return <InputField {...props} ref={ref} InputComponent={<input />} />;
});

export default TextField;
